import styled from "@emotion/styled";
import { Typography } from "@mui/material";

const DialogContentHeader = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
}));

DialogContentHeader.defaultProps = {
  variant: "subtitle1",
};

export default DialogContentHeader;
